import { ReactNode } from 'react';

export enum LegalStringColor {
	lead = 'lead',
	supporting = 'supporting',
	inverse = 'inverse',
}

export interface LegalStringProps {
	className?: string;
	children: string | ReactNode;
	footnote?: string | number;
	color?: LegalStringColor;
}
